/* Matcha Sunday: fast, smooth mobile menu drawer open.
   The Impact navigation drawer opens with (a) a staggered clip-path "wipe" on the panel and
   (b) a ~700ms opacity/visibility fade. On our floating left panel that reads as slow and shows
   a flash. On open we cancel the clip-path wipe (so it does not fight our CSS slide) and FINISH
   the fade animations instantly, so the only motion is our fast CSS transform slide. Nothing else
   about the drawer (open trigger, close, sub-panels, B2B gating) changes. */
(function () {
  function snap(dr, sr, content) {
    var els = [dr, content];
    ['overlay', 'outside-close-button', 'header'].forEach(function (p) {
      var el = sr.querySelector('[part="' + p + '"]');
      if (el) els.push(el);
    });
    els.forEach(function (el) {
      if (!el || !el.getAnimations) return;
      el.getAnimations().forEach(function (a) {
        try {
          var ef = a.effect;
          var kf = ef && ef.getKeyframes ? ef.getKeyframes() : [];
          var isClip = kf.some(function (k) { return 'clipPath' in k || 'clip-path' in k; });
          if (isClip) { a.cancel(); }       // drop the wipe entirely (our CSS slide replaces it)
          else { a.finish(); }              // jump the fade to done so the panel appears at once
        } catch (e) {}
      });
    });
    content.style.clipPath = 'none';
  }

  function attach(dr) {
    if (!dr || dr.__msSmooth) return true;
    var sr = dr.shadowRoot;
    if (!sr) return false;
    var content = sr.querySelector('[part="content"]');
    if (!content) return false;
    dr.__msSmooth = true;
    var run = function () {
      if (!dr.hasAttribute('open')) return;     // only act on open, never on close
      snap(dr, sr, content);
      requestAnimationFrame(function () {
        snap(dr, sr, content);
        requestAnimationFrame(function () { snap(dr, sr, content); });
      });
    };
    new MutationObserver(run).observe(dr, { attributes: true, attributeFilter: ['open'] });
    if (dr.hasAttribute('open')) run();
    return true;
  }

  function init(tries) {
    var all = document.querySelectorAll('navigation-drawer');
    var pending = false;
    all.forEach(function (dr) { if (!attach(dr)) pending = true; });
    if ((pending || !all.length) && (tries || 0) < 40) {
      setTimeout(function () { init((tries || 0) + 1); }, 150);
    }
  }

  if (document.readyState !== 'loading') init(0);
  else document.addEventListener('DOMContentLoaded', function () { init(0); });
})();
